import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError,map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';



@Injectable()
export class LanguageService {
    private dataSource = new BehaviorSubject({name: 'English',Id:1});
currentData = this.dataSource.asObservable();
mySubject : BehaviorSubject<any> = new BehaviorSubject<any>([]);
userData : BehaviorSubject<any> = new BehaviorSubject<any>([]);
myData : any ;


    constructor(private _httpClient: HttpClient) { }
    getLanguages(): Observable<any> {
        return this._httpClient.get(environment.APIEndpoint + 'api/Language/GetLanguages')
            .pipe(map((data) => data),
                catchError(this.handleError));
    }

    getAllLanguages(): Observable<any>{
        return this._httpClient.get(environment.APIEndpoint + 'api/Language/GetLanguageList')
            .pipe(map((data) => data),
                catchError(this.handleError));
    }

    getEngagementSelectedLanguages(engagementId: number):Observable<any> {
        return this._httpClient.get(environment.APIEndpoint + 'api/Language/GetEngagementSelectedLanguages?engagementId=' + engagementId)
            .pipe(map((data) => data),
                catchError(this.handleError));
    }

    private handleError(error: Response) {
        console.error(error);
        return throwError(error || 'Server error');
    }

    public changeLanguage(data: any) {
        this.dataSource.next(data);
      }

      public myDataSetter(data : any){
        this.myData = data;
        this.mySubject.next(this.myData);
       }

       public userDataSetter(data : any){
        var data = data;
        this.userData.next(data);
       }
}